/**
 * Default feature flags for Killswitch Flags
 * */
export default {
  oneokSwiftComponentPreview: false,
  oneokSwiftDispatching: false,
  oneokSwiftGlobal: true,
  oneokSwiftInventory: true,
  oneokSwiftLoading: true,
  oneokSwiftShipping: true,
  oneokSwiftSwiftPlus: false,
};
